import React from 'react'
import Manager from '../../public/components/Manager'
Ext.require('Ext.Toast')

const config = {
    tabs:
    {
        确认中: {
            buttons: [
            ],
            columns: [
                { _text: '发放月份', field: 'SalaryApply.Issue', minWidth: 250, search: true, },
                { _text: '员工编号', field: '_PersonNo', minWidth: 150, },
                { _text: '员工姓名', field: 'PersonName', minWidth: 150, flex: 10, search: true },
                { _text: '科目代码', minWidth: 150, flex: 10, search: true },
                { _text: '科目名称', minWidth: 150, search: true, },
                { _float: '加扣金额（元）', field: 'Amount', minWidth: 150, filter: true, },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
            }
        },
        全部: {
            buttons: [
            ],
            columns: [
                { _text: '发放月份', field: 'SalaryApply.Issue', minWidth: 250, search: true, },
                { _text: '员工编号', field: '_PersonNo', minWidth: 150, },
                { _text: '员工姓名', field: 'PersonName', minWidth: 150, flex: 10, search: true },
                { _text: '科目代码', minWidth: 150, flex: 10, search: true },
                { _text: '科目名称', minWidth: 150, search: true, },
                { _float: '加扣金额（元）', field: 'Amount', minWidth: 150, filter: true, },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
            }
        }
    }
}

export default props => <Manager {...props} config={config} />